module.exports = __webpack_public_path__ + "img/mobile_bg.0bd269f0.png";